import formValidateMixin from "../mixins/form-validate";
import ModalMixin from "../mixins/modal";
import Axios from 'axios';
export default {
  name: "user-register",
  props: ["title", "value"],
  mixins: [formValidateMixin, ModalMixin],
  data: function data() {
    return {
      data: {
        username: "",
        realname: "",
        password: "",
        password2: "",
        email: "",
        mobile: "",
        employer: "",
        title: "",
        remark: ""
      },
      rules: {
        username: {
          type: "string",
          required: true,
          min: 2,
          max: 20
        },
        realname: {
          type: "string",
          required: true,
          min: 2,
          max: 20
        },
        password: [{
          type: "string",
          required: true,
          min: 2,
          max: 20
        }, {
          validator: this.passwordConfirmValidator
        }],
        password2: [{
          type: "string",
          required: true,
          min: 2,
          max: 20
        }, {
          validator: this.passwordConfirmValidator
        }],
        email: {
          type: "email",
          required: true
        },
        mobile: {
          type: "string",
          required: true,
          pattern: /^((13[0-9])|(14[5,7,9])|(15[^4])|166|(18[0-9])|(17[0,1,3,5,6,7,8]))\d{8}$$/
        }
      },
      loading: false
    };
  },
  methods: {
    handleOk: function handleOk() {
      var _this = this;
      var data = this.data;
      this.loading = true;
      return Axios.get("csrftoken/").then(function () {
        return Axios.post("users/", {
          email: data.email,
          employer: data.employer,
          job_title: data.title,
          mobile: data.mobile,
          password: data.password,
          realname: data.realname,
          remark: data.remark,
          username: data.username
        }).then(function () {
          _this.loading = false;
          _this.$Message.success('已经提交成功，请等待管理员审核，关注邮箱动态。');
        }, function (e) {
          _this.loading = false;
          throw e;
        });
      });
    },
    resetData: function resetData() {
      this.$refs.form.resetFields();
      this.isFormValid = false;
      this.loading = false;
    },
    passwordConfirmValidator: function passwordConfirmValidator(rule, value, callback) {
      var result = true;
      var data = this.data;
      if (data.password2 && data.password) {
        result = data.password === data.password2;
        this._syncPasswordFields(rule.field === "password" ? "password2" : "password", result);
      }
      if (result) {
        callback();
      } else {
        callback([new Error("密码不一致")]);
      }
    },
    /**
     * 校验密码时，需要同步验证确认密码是不是有效。反之亦然
     */
    _syncPasswordFields: function _syncPasswordFields(field, value) {
      var item = this.$refs[field];
      var SUCCESS = "success";
      var ERROR = "error";
      if (value) {
        if (item.validateState === ERROR) {
          item.validateState = SUCCESS;
        }
      } else {
        if (item.validateState === SUCCESS) {
          item.validateState = ERROR;
        }
      }
    }
  }
};